import '@/styles/style.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { DefaultApolloClient } from '@vue/apollo-composable';

import type { AppModule } from '@ohmybible/core';

import App from '@/App.vue';
import { apolloClient } from '@/core/apollo/client';
import { i18n, setupI18n } from '@/core/i18n';
import { registerModules } from '@/core/register-modules';
import router from '@/core/router';

import { AuthModule } from '@/modules/auth';
import { HomeModule } from '@/modules/home';
import { KitModule, kitMessages } from '@/modules/kit';
import { ReaderModule, readerEnabled } from '@/modules/reader';
import { ProfileModule } from '@/modules/profile';

setupI18n();

const modules: Record<string, AppModule> = {
  AuthModule,
  HomeModule,
  ProfileModule,
};

if (readerEnabled) {
  modules['ReaderModule'] = ReaderModule;
}

// The component kit exists on local workspaces only (dev server and local
// builds alike), never in a release build.
if (import.meta.env.VITE_APP_ENV === 'local') {
  modules['KitModule'] = KitModule;
  i18n.global.mergeLocaleMessage('en', kitMessages.en);
}

registerModules(modules);

const app = createApp(App);

app.use(createPinia());
app.use(i18n);
app.provide(DefaultApolloClient, apolloClient);
app.use(router);

void router.isReady().then(() => {
  app.mount('#app');
});
